/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricIdentity {
    getFixupPrototypeFunction() { return UtilizationMetricIdentity.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricIdentity>): UtilizationMetricIdentity {
        let obj = Object.assign(new UtilizationMetricIdentity(), model);
        UtilizationMetricIdentity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricIdentity>): UtilizationMetricIdentity {
        if (!model) return null;
        return UtilizationMetricIdentity.newInstance(<UtilizationMetricIdentity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricIdentity) {
        if (!obj) return;

        models.UtilizationMetricIdentity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricIdentity): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricIdentity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * service account id
     */
    service_account_id: string;

    /**
     * resource region
     */
    resource_region: string;

    /**
     * resource id
     */
    resource_id: string;

    /**
     * metric name
     */
    metric_name: string;

}
